import { inject } from 'mobx-react';
import * as React from 'react';

import { Context } from 'bernie-context';
import { ExperimentStore } from 'bernie-core';

export interface PropertyReviewsProps {
  localizedCountWithLabel?: string;
  localizedOverallRating?: string;
  superlative?: string;
  experiment?: ExperimentStore;
}

export interface SearchResultsReviewsProps {
  className?: string | string[];
  context?: Context;
  reviews?: {
    localizedCount?: string;
    localizedOverallRating?: string;
    superlative?: string;
  };
}

export interface SuperlativeProps {
  superlative: string;
}

const searchResultsReviews = ({ className, reviews }: SearchResultsReviewsProps) => {
  if (!reviews) {
    return null;
  }
  const localizedCount = reviews && reviews.localizedCount;
  const localizedOverallRating = reviews && reviews.localizedOverallRating;
  const superlative = reviews && reviews.superlative;

  return (
    <div className={`${className}`} data-stid="search-results-reviews">
      {reviews && (
        <PropertyReviews
          localizedCountWithLabel={localizedCount}
          localizedOverallRating={localizedOverallRating}
          superlative={superlative}
        />
      )}
    </div>
  );
};

export const PropertyReviews: React.FC<PropertyReviewsProps> = inject('experiment')(
  ({ experiment, localizedCountWithLabel, localizedOverallRating, superlative }) => {
    const isPropertyNameExperiment =
      experiment &&
      experiment.exposures &&
      experiment.exposures.SRP_propertyName_SingleCol &&
      experiment.exposures.SRP_propertyName_SingleCol.bucket &&
      experiment.exposures.SRP_propertyName_SingleCol.bucket !== 0;
    const propertyReviewClass = isPropertyNameExperiment ? '' : 'truncate';

    return (
      <div data-stid="content-hotel-review-info" className={propertyReviewClass}>
        {localizedOverallRating && (
          <span className="uitk-type-300 uitk-type-bold all-r-padding-one" data-stid="content-hotel-reviews-rating">
            {localizedOverallRating}
            /5
          </span>
        )}
        {superlative && <Superlative superlative={superlative} />}
        {localizedCountWithLabel && (
          <span className="pwa-theme--grey-700" data-stid="content-hotel-reviews-total">
            ({localizedCountWithLabel})
          </span>
        )}
      </div>
    );
  }
);
PropertyReviews.displayName = 'PropertyReviews';

export const Superlative = ({ superlative }: SuperlativeProps) => (
  <span className="uitk-type-300 pwa-theme--grey-700 all-r-padding-one" data-stid="content-hotel-reviews-superlative">
    {superlative}
  </span>
);
Superlative.displayName = 'Superlative';

export const SearchResultsReviews = inject('context')(searchResultsReviews) as React.ComponentType<SearchResultsReviewsProps>;
